module.exports = __webpack_public_path__ + "static/header-image_FFC_KH-football-540e0e735f78edbbf8dd6fb1dc22fb60.png";